export default __webpack_public_path__ + "static/media/1576.bdfc1f13.png";